// replyMessage.js
'use strict';
import getOperationData from '../selector/getOperationData.js';
import getMessageData from '../selector/getMessageData.js';
import getUserData from '../selector/getUserData.js';

import checkChatMessageDraft from '../action/checkChatMessageDraft.js';
import setReplyMessageStatus from '../action/setReplyMessageStatus.js';
import sendChatStart from '../action/sendChatStart.js';
import setMessageReplyInputValue from '../action/setMessageReplyInputValue.js';
import prepareChatMessage from '../action/prepareChatMessage.js';

/**
 * Reply message
 * @kind action
 * @param {string} {messageId} - which message id been replied.
 * @param {string} {text} - reply message text.
 * @param {object} {media} - reply message media.
 * @return {Promise} Action promise.
 */
const replyMessage =
  ({ messageId, text, media }) =>
  async (dispatch, getState) => {
    const replySelectPath = ['message', messageId];
    const isSending = getOperationData(
      getState(),
      replySelectPath,
      'replyIsSending'
    );
    if (!messageId || isSending) {
      return dispatch({ type: '' });
    }
    try {
      dispatch(setReplyMessageStatus({ messageId, replyIsSending: true }));
      const senderId = getMessageData(getState(), messageId, 'senderId');
      const replyPrice = getUserData(getState(), senderId, 'replyPrice');
      await dispatch(
        checkChatMessageDraft({
          text,
          media,
          replyPrice,
        })
      );
      await dispatch(sendChatStart({ userId: senderId }));
      const chatroomId = window.location.pathname.split('/').slice(-1)[0];
      dispatch(setMessageReplyInputValue({ messageId, text: '', media: null }));
      dispatch(setReplyMessageStatus({ messageId, replyIsSending: false }));
      return dispatch(
        prepareChatMessage({
          text,
          media,
          chatroomId,
          replyMessageId: messageId,
        })
      );
    } catch (error) {
      dispatch(setReplyMessageStatus({ messageId, replyIsSending: false }));
    }
  };

export default replyMessage;
